<div class="rt-editor"></div>
<div ng-show="$ctrl.isTextOnly" class="text-editor">
    <textarea ng-model="$ctrl.textEditorValue" ng-blur="$ctrl.textEditorBlurred()"></textarea>
</div>
<div ng-if="$ctrl.showBottomRow" class="trumbowyg-button-pane centuri-buttons">
    <div class="text-only">
        <c-checkbox checked="$ctrl.isTextOnly" label="$ctrl.textOnlyLabel"></c-checkbox>
    </div>
    <div class="properties" ng-if="$ctrl.config.properties.length">
        {{'rte.properties'|translate}}
        <select ng-model="$ctrl.property" ng-options="property for property in $ctrl.config.properties">
            <option value="">{{"emptyTextSelect"|translate}}</option>
        </select>
    </div>
    <div class="selected-locale" ng-show="$ctrl.locales.length > 1">
        <span ng-if="$ctrl.missingSystemLocale" class="missing-locale">{{$ctrl.missingTranslation}}</span>
        <span>{{"rte.selectedLocale"|translate}}</span>
        <select ng-options="item as item.label for item in $ctrl.locales track by item.id" ng-model="$ctrl.selectedLocale"></select>
    </div>
</div>
